import { retrieveLaunchParams } from '@tma.js/sdk'

export function getTelegramInitData(): string {
  // Use TMA SDK which handles all launch param sources (URL hash, window.Telegram.WebApp, etc.)
  try {
    const params = retrieveLaunchParams()
    if (params?.initDataRaw) return params.initDataRaw
  } catch {
    // Fall through to classic API
  }
  // Fallback: classic Telegram WebApp API
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initData) {
    return window.Telegram.WebApp.initData
  }
  return ''
}

export function getTelegramUser() {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initDataUnsafe?.user) {
    return window.Telegram.WebApp.initDataUnsafe.user
  }
  return null
}

interface SafeAreaInset {
  top: number
  bottom: number
  left: number
  right: number
}

/**
 * Initialize Telegram Mini App: expand, ready, and set up safe area CSS vars.
 * Call once at app startup.
 */
export function setupTelegramApp(): void {
  const webApp = window.Telegram?.WebApp
  if (!webApp) return

  webApp.ready()
  webApp.expand()

  const root = document.documentElement

  const applySafeArea = () => {
    const sa: SafeAreaInset = (webApp as any).safeAreaInset || { top: 0, bottom: 0, left: 0, right: 0 }
    root.style.setProperty('--tg-safe-area-inset-top', `${sa.top}px`)
    root.style.setProperty('--tg-safe-area-inset-bottom', `${sa.bottom}px`)
    root.style.setProperty('--tg-safe-area-inset-left', `${sa.left}px`)
    root.style.setProperty('--tg-safe-area-inset-right', `${sa.right}px`)
  }

  const applyContentSafeArea = () => {
    const csa: SafeAreaInset = (webApp as any).contentSafeAreaInset || { top: 0, bottom: 0, left: 0, right: 0 }
    root.style.setProperty('--tg-content-safe-area-inset-top', `${csa.top}px`)
    root.style.setProperty('--tg-content-safe-area-inset-bottom', `${csa.bottom}px`)
    root.style.setProperty('--tg-content-safe-area-inset-left', `${csa.left}px`)
    root.style.setProperty('--tg-content-safe-area-inset-right', `${csa.right}px`)
  }

  applySafeArea()
  applyContentSafeArea()

  ;(webApp as any).onEvent?.('safeAreaChanged', applySafeArea)
  ;(webApp as any).onEvent?.('contentSafeAreaChanged', applyContentSafeArea)
}

declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: {
          user?: {
            id: number
            first_name: string
            last_name?: string
            username?: string
            language_code?: string
          }
        }
        ready(): void
        close(): void
        expand(): void
        BackButton: {
          show(): void
          hide(): void
          onClick(cb: () => void): void
          offClick(cb: () => void): void
        }
        MainButton: {
          text: string
          show(): void
          hide(): void
          onClick(cb: () => void): void
          setParams(params: { text?: string; is_active?: boolean; is_visible?: boolean }): void
        }
      }
    }
  }
}
